import { faPenToSquare } from "@fortawesome/pro-regular-svg-icons"
import { IAdvertiser } from "advertiser/model"
import { translate } from "app/language/service"
import { ADVERTISER_UPDATE_PATH } from "page/model"
import { navigate } from "page/tools/navigate"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { ListActionButton } from "ui/components/main-layout/ListActionButton"

interface IAdvertiserListActionProps {
  advertiser: IAdvertiser
}

export const AdvertiserListAction = React.memo(
  ({ advertiser }: IAdvertiserListActionProps): JSX.Element => (
    <FlexBox
      sx={{
        gap: ".5rem",
        fontSize: "1.5rem"
      }}>
      <ListActionButton
        icon={faPenToSquare}
        tooltip={translate("advertiser.edit")}
        onClick={() => navigate({ path: ADVERTISER_UPDATE_PATH, pathParams: advertiser.id })}
      />
    </FlexBox>
  )
)
